import { useEffect, useState } from "react"
import { Countries } from "../../utils/Countries"
import { FormContextType, useForm } from "../../contexts/formContext"
import CheckoutShippingEvents from "../events/checkoutShippingEvents"
import { PlaceType } from "../components/steps/CheckoutShippingAddress"
import CheckoutShippingAddressEvents from "../events/checkoutShippingAddressEvents"

const useCheckoutShippingAddress = (
  type: "shipping" | "billing",
  onChange: (() => void) | undefined
) => {
  const { formState, formActions } = useForm() as FormContextType

  const [loaded, setLoaded] = useState(false)
  const [autocompleteOptions, setAutocompleteOptions] = useState<PlaceType[]>(
    []
  )

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    CheckoutShippingAddressEvents.handleChange(
      e,
      type,
      formActions,
      onChange,
      setAutocompleteOptions,
      formState
    )
  }

  const handleSelectAddress = (option: any) =>
    CheckoutShippingAddressEvents.handleSelectAddress(option, type, formActions)

  const handleKeyDown = (e: React.KeyboardEvent) => {
    CheckoutShippingAddressEvents.handleKeyDown(e, type, formActions)
  }

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    CheckoutShippingAddressEvents.handleOnFocus(e)
  }

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    CheckoutShippingAddressEvents.handleOnBlur(formState, type)
  }

  const countryList = Array.from(Countries.keys()).sort((a, b) => {
    var nameA = a.toUpperCase() // ignore upper and lowercase
    var nameB = b.toUpperCase() // ignore upper and lowercase
    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    // names must be equal
    return 0
  })

  /**
   * Effects
   */
  useEffect(() => {
    CheckoutShippingEvents.initGoogleMaps(loaded, setLoaded)
  }, [])

  return [
    autocompleteOptions,
    handleChange,
    handleSelectAddress,
    handleKeyDown,
    handleOnFocus,
    handleOnBlur,
    countryList,
  ] as const
}

export default useCheckoutShippingAddress
